import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { AttendanceMetricsProps } from './HistoryNotesPanel.props';

interface MetricItemProps {
  label: string;
  value: string;
}

const MetricItem: React.FC<MetricItemProps> = ({ label, value }) => (
  <Box
    sx={{
      flex: 1,
      textAlign: 'center',
      py: 1,
      px: 1.5,
      bgcolor: 'v4.tableEven',
      borderRadius: 1,
    }}
  >
    <Typography
      sx={{
        fontSize: '18px',
        fontWeight: 700,
        color: 'text.primary',
      }}
    >
      {value}
    </Typography>
    <Typography
      sx={{
        fontSize: '10px',
        fontWeight: 600,
        color: 'text.secondary',
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
      }}
    >
      {label}
    </Typography>
  </Box>
);

const formatDuration = (minutes: number): string => {
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
};

export const AttendanceMetrics: React.FC<AttendanceMetricsProps> = ({
  logs,
}) => {
  const attendanceLogs = logs.filter(
    (log) => String(log.type ?? '').toLowerCase() === 'attendance',
  );

  const totalVisits = attendanceLogs.length;

  const totalMinutes = attendanceLogs.reduce((sum, log) => {
    const duration = Number(log.duration ?? 0);
    return sum + (isNaN(duration) ? 0 : duration);
  }, 0);

  const avgDuration =
    totalVisits > 0 ? Math.round(totalMinutes / totalVisits) : 0;

  return (
    <Box sx={{ display: 'flex', gap: 1.5, mb: 1.5 }}>
      <MetricItem label="Total Visits" value={String(totalVisits)} />
      <MetricItem
        label="On-Site Time"
        value={formatDuration(totalMinutes)}
      />
      <MetricItem
        label="Avg Duration"
        value={formatDuration(avgDuration)}
      />
    </Box>
  );
};
